import axios from 'axios';

import {
	Loading
} from 'element-ui';

import toastr from '../toastr';

const UPDATE_MESSAGE = 'Nosso sistema está passando por uma atualização. Por favor, tente novamente em alguns instantes.';
const SUPPORT_MESSAGE = 'Idenficamos um problema. Por favor, entre em contato com o suporte.';

const Http = axios.create({
	baseURL: '/api/',
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json; charset=utf-8'
	}
});

const loadingInstances = {};
const loadingOptions = {
	text: 'Carregando...'
};

Http.interceptors.request.use((config) => {

	config.startTime = new Date().getTime();

	loadingInstances[config.startTime] = Loading.service(loadingOptions);

	return config;

}, (error) => {

	loadingInstances[error.response.config.startTime].close();

	return Promise.reject(error);

});

Http.interceptors.response.use((response) => {

	response.config.endTime = new Date().getTime();
	loadingInstances[response.config.startTime].close();

	return response;

}, (error) => {

	if (error.response) {

		const {
			status,
			data
		} = error.response;

		if (status === 404) {
			toastr.error(UPDATE_MESSAGE);
		}

		if (data.statusDescription) {

			if (status === 400 || status === 401 || status === 500) {
				toastr.error(data.statusDescription);
			}

			if (status === 412) {
				toastr.warning(data.statusDescription);
			}

		} else {

			if (status === 500) {
				toastr.error(SUPPORT_MESSAGE);
			}

		}

	}

	loadingInstances[error.response.config.startTime].close();

	return Promise.reject(error);

});

export default Http;



// WEBPACK FOOTER //
// ./sources/support/http/index.js